<template>
  <div class="invitacion-container">

    <div class="invitacion-card">
      <img src="@/assets/Elements (63).avif" alt="Sello decorativo" class="sello-decorativo" />
      <img src="@/assets/Elements (63).avif" alt="Sello decorativo" class="sello-decorativo" />

      <div class="flores-decorativas"></div>

      <h1 ref="titulo" class="titulo-principal"> </h1>
      <p ref="nombres" class="subtitulo">
      Frida Acevedo
      </p>
      <p ref="fecha" class="fecha">17 • Octubre • 2026</p>

      <div class="seccion-idiomas" ref="idiomaSeccion">
        <p class="instruccion"> Bienvenidos a mi invitación.</p>
        <div class="opciones-idioma">
          <button @click="seleccionar('es')" class="btn-idioma">
            <span>Ingresar </span>
          </button>
      
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const ramaIzquierda = ref(null);
    const ramaDerecha = ref(null);
    const titulo = ref(null);
    const nombres = ref(null);
    const ampersand = ref(null);
    const fecha = ref(null);
    const idiomaSeccion = ref(null);

    const seleccionar = (idioma) => {
      emit('idioma-seleccionado', idioma);
    };

    onMounted(() => {
      gsap.from(ramaIzquierda.value, {
        x: -200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
      });

      gsap.from(ramaDerecha.value, {
        x: 200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
        delay: 0.3,
      });

      // Animación de entrada escalonada
      gsap.timeline({ delay: 0.5 })
        .from(titulo.value, {
          opacity: 0,
          y: -30,
          duration: 1,
          ease: 'power2.out',
        })
        .from(nombres.value, {
          opacity: 0,
          y: 30,
          duration: 1.2,
          ease: 'back.out(1.7)',
        }, '-=0.5')
        .from(ampersand.value, {
          scale: 0,
          opacity: 0,
          duration: 0.6,
          ease: 'elastic.out(1, 0.5)',
        }, '-=1')
        .from(fecha.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8');
    });

    return {
      seleccionar,
      ramaIzquierda,
      ramaDerecha,
      titulo,
      nombres,
      ampersand,
      fecha,
      idiomaSeccion,
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500&family=Dancing+Script:wght@700&display=swap');

.invitacion-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin-top: -60px;
  padding: 1rem;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
}

.ramita {
  position: absolute;
  top: 50%;
  width: 120px;
  transform: translateY(-50%);
  z-index: 0;
  pointer-events: none;
}

.ramita.izquierda {
  left: 0;
}

.ramita.derecha {
  right: 0;
  transform: translateY(-50%) scaleX(-1);
}

.invitacion-card {
  position: relative;
  padding: 80px 20px;
  margin: 0 auto;
  border-radius: 0 80px 0 80px;
     background:
    linear-gradient(
      rgba(214, 172, 172, 0.836),
      rgba(208, 152, 180, 0.664)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;  text-align: center;
  width: 100%;
  max-width: 380px;
  z-index: 1;
  animation: fadeIn 1s ease-out;
}

.flores-decorativas {
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  opacity: 0.7;
}

.titulo-principal {
  font-family: 'Dancing Script', cursive;
  font-size: 2.5rem;
  color: #eae4e6;
  margin-bottom: 0.5rem;
  letter-spacing: 1px;
}

.subtitulo {
  font-family: 'bethany', sans-serif;
  margin-top: 20px;
  font-size: 1.8rem;
  color: #f4e9ec;
  margin-bottom: 1rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.ampersand {
  font-family: 'starlove', cursive;
  font-size: 2.4rem;
  color: #f5e9ed;
  padding: 0 0.3rem;
  display: inline-block;
  transform: translateY(2px);
}

.fecha {
  font-family: 'fa';
  font-size: 1.6rem !important;
  color: #faf0f3;
  margin-bottom: 2rem;
  letter-spacing: 1px;
}

.seccion-idiomas {
  margin: 2rem 0;
}

.instruccion {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  color: #fef3f6;
  margin-bottom: 1.5rem;
  font-weight: 400;
}

.opciones-idioma {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.btn-idioma {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  background: #fff;
  border: 1px solid #ece5e7;
  border-radius: 12px;
  color: #5f4b32;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.btn-idioma:hover {
  background: #f8e8e8;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.bandera {
  width: 24px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
}

.sello-decorativo {
  width: 80px;
  height: auto;
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  opacity: 0.9;
  z-index: 2;
}

@media (max-width: 480px) {
  .invitacion-card {
    padding: 2rem 1rem;
  }
  .titulo-principal {
    font-size: 2rem;
  }
  .subtitulo {
    font-size: 2rem;
  }
  .fecha {
    font-size: 1.2rem;
  }
}
</style>
